import { createApp } from 'vue';
import App from './App.vue';

import Amplify from 'aws-amplify';
import amplifyProd from './aws-exports';      // production config
import amplifyDev  from './aws-exports-dev';  // dev‑time copy
import amplifyTest from './aws-exports-test'; // test environment config

import router from './router';
import axios from 'axios';

/* ------------------------------------------------------------------ */
/*  Detect environment mode                                            */
/* ------------------------------------------------------------------ */
const isTest = process.env.VUE_APP_ENVIRONMENT === 'test' ||
  process.env.NODE_ENV === 'test' ||
  (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.MODE === 'test');

const isDev =
  // Vite / Rollup:  import.meta.env.MODE === 'development'
  (typeof import.meta !== 'undefined' &&
   import.meta.env &&
   import.meta.env.MODE === 'development')
  ||
  // Vue‑CLI / webpack: NODE_ENV !== 'production'
  process.env.NODE_ENV !== 'production';

// Configure Amplify based on environment
if (isTest) {
  Amplify.configure(amplifyTest);
} else {
  Amplify.configure(isDev ? amplifyDev : amplifyProd);
}

/* ------------------------------------------------------------------ */
/*  Optional – give Axios the same base URL that your helper script   */
/*  wrote to .env.(development|production)                            */
/* ------------------------------------------------------------------ */
if (process.env.VUE_APP_API_BASE_URL) {
  axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
}

/* ------------------------------------------------------------------ */
/*  Create & mount the Vue app                                        */
/* ------------------------------------------------------------------ */
const app = createApp(App);

app.config.globalProperties.$axios = axios;
app.use(router);
app.mount('#app');
